// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/metar-weather-codes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/metar-weather-codes/metar-weather-codes.js';

mount([g0]);
